


































































import {Component, Mixins} from 'vue-property-decorator';
import {ProductType} from '@/types/claim';
import AmountMixin from '@/components/claim/popup/mixins/AmountMixin';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {isCancelExchange, isExchangeClaim} from '@/components/claim/popup/validations';

// 교환 상품 차액상세(취소교환, 반품교환) https://nhnent.dooray.com/project/posts/2711586720074695171
@Component({
  components: {
    CompSelectBox
  },
  computed: {
    isExchangeClaim,
    isCancelExchange
  }
})
export default class ProductAmount extends Mixins(AmountMixin){
  // 상품합계차액 row (+)
  private productAmt = {
    exchangeProductAmt: 0, // 교환상품
    retrunProductAmt: 0, // 반품상품

    get difference(){ // 상품합계차액
      return this.exchangeProductAmt - this.retrunProductAmt
    }
  }

  // 추가할인차액 row (-)
  private additionalDiscountAmt = {
    exchangeProductDiscountAmt: 0, // 교환상품
    returnProductDiscountAmt: 0, // 반품상품

    get difference(){
      return this.exchangeProductDiscountAmt - this.returnProductDiscountAmt
    }
  }

  // 상품쿠폰 재계산 row (-)
  private coupon = {
    recalculatedAmt: 0,
    productCoupons: []
  }

  // 교환금액합계 row (a)
  private exchangeAmt = {
    totalExchangeAmt: 0
  }

  created(){
    this.setProductAmt()
    this.setAdditionalDiscountAmt()
    this.setCoupon()
    this.setExchangeAmt()
  }

  private setProductAmt(){
    this.productAmt.exchangeProductAmt = this.exchangeImmediateDiscountedAmt({type: ProductType.EXCHANGE_PRODUCT, needSum: true})
    this.productAmt.retrunProductAmt = this.exchangeImmediateDiscountedAmt({type: ProductType.CLAIMED_PRODUCT, needSum: true})
  }

  private setAdditionalDiscountAmt(){
    const CLAIMED_OPTION = 0;
    const {additionalDiscountAmt: exchangeAdditionalDiscountAmt, orderCnt: exchangeOrderCnt} = this.claimNoResponseData.exchangeOption
    this.additionalDiscountAmt.exchangeProductDiscountAmt = exchangeAdditionalDiscountAmt * exchangeOrderCnt

    const {additionalDiscountAmt: refundAdditionalDiscountAmt, orderCnt: refundOrderCnt} = this.claimNoResponseData.claimedOptions[CLAIMED_OPTION]
    this.additionalDiscountAmt.returnProductDiscountAmt = refundAdditionalDiscountAmt * refundOrderCnt
  }

  private setCoupon(){
    const recalculatedAmt = this.claimNoResponseData.claimData.amounts.refund.coupon.productCouponDiscountAmt

    const productCoupons = this.claimNoResponseData.claimData.coupon.productCoupons
    if(!productCoupons){
      this.coupon = {...this.coupon, recalculatedAmt}
      return
    }

    this.coupon = {recalculatedAmt, productCoupons}
  }

  private setExchangeAmt(){
    const {productCouponDiscountAmt} = this.amounts.refund.coupon
    // 상품쿠폰 재계산(productCouponDiscountAmt) 표기는 minusComma, 계산은 +로 해야한다.
    this.exchangeAmt.totalExchangeAmt = this.productAmt.difference - this.additionalDiscountAmt.difference + productCouponDiscountAmt - (this.claimNoResponseData.exchangeDifferenceAdjustAmt || 0)
  }
}
